<template>
  <aside
    class="sidebar w-64 md:shadow transform -translate-x-full md:translate-x-0 transition-transform duration-150 ease-in bg-white"
  >
    <div class="sidebar-header flex items-center justify-center py-4">
      <div class="inline-flex">
        <a href="#" class="inline-flex flex-row items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="121"
            height="64.925"
            viewBox="0 0 121 64.925"
          >
            <g
              id="dkilo_logo"
              data-name="dkilo logo"
              transform="translate(-40 -31.124)"
            >
              <g
                id="white_dkilo_logo"
                data-name="white dkilo logo"
                transform="translate(40 31.124)"
              >
                <g id="c">
                  <g id="Group_15925" data-name="Group 15925">
                    <g
                      id="Group_15922"
                      data-name="Group 15922"
                      transform="translate(36.858 7.55)"
                    >
                      <g
                        id="Group_15921"
                        data-name="Group 15921"
                        transform="translate(28.184 6.634)"
                      >
                        <rect
                          id="Rectangle_1838"
                          data-name="Rectangle 1838"
                          width="7.55"
                          height="7.55"
                          transform="translate(7.55) rotate(90)"
                          fill="#369da3"
                        />
                        <path
                          id="Path_25624"
                          data-name="Path 25624"
                          d="M185.127,85.83v32.543H177.61V85.83Z"
                          transform="translate(-177.592 -68.573)"
                          fill="#369da3"
                        />
                      </g>
                      <path
                        id="Path_25625"
                        data-name="Path 25625"
                        d="M215.957,20.61V77.044H208.44V20.61Z"
                        transform="translate(-168.944 -20.61)"
                        fill="#369da3"
                      />
                      <path
                        id="Path_25626"
                        data-name="Path 25626"
                        d="M235.55,100.3a16.177,16.177,0,0,1,5.044-12,17.8,17.8,0,0,1,24.66.033,17.428,17.428,0,0,1-.033,24.492,17.238,17.238,0,0,1-12.462,4.912,16.472,16.472,0,0,1-12.264-5.011A16.854,16.854,0,0,1,235.55,100.3Zm7.685.132a10.98,10.98,0,0,0,2.6,7.718,10.135,10.135,0,0,0,14.1.033,10.706,10.706,0,0,0,2.641-7.586,10.69,10.69,0,0,0-2.641-7.586,9.178,9.178,0,0,0-7.052-2.872,9.021,9.021,0,0,0-6.982,2.872,10.45,10.45,0,0,0-2.674,7.418Z"
                        transform="translate(-186.124 -60.374)"
                        fill="#369da3"
                      />
                      <path
                        id="Path_25627"
                        data-name="Path 25627"
                        d="M114.686,58.164,128.819,44.5H118.727l-10.59,10.524V20.61H104.4v3.777H100.62V77.044h7.517V64.512l1.205-1.2L120.1,77.044h9.759L114.69,58.164Z"
                        transform="translate(-100.62 -20.61)"
                        fill="#369da3"
                      />
                    </g>
                    <g id="Group_15924" data-name="Group 15924">
                      <g
                        id="Group_15923"
                        data-name="Group 15923"
                        transform="translate(0 3.777)"
                      >
                        <path
                          id="Path_25628"
                          data-name="Path 25628"
                          d="M25.528,24.387V48.277a14.054,14.054,0,0,0-21.147.234A17.507,17.507,0,0,0,0,60.673,18.344,18.344,0,0,0,4.377,73.106a14.313,14.313,0,0,0,11.092,4.879,14.023,14.023,0,0,0,10.059-4.344v3.407h7.553V28.16H29.3V24.383H25.528Zm-2.1,44a8.632,8.632,0,0,1-6.751,2.876,8.22,8.22,0,0,1-6.484-2.974,11.341,11.341,0,0,1-2.506-7.619,10.839,10.839,0,0,1,2.575-7.352,8.308,8.308,0,0,1,6.484-2.938,8.493,8.493,0,0,1,6.682,2.909A11.126,11.126,0,0,1,26,60.842,11.136,11.136,0,0,1,23.426,68.4ZM33.082,20.61H29.3v3.777h3.777Z"
                          transform="translate(0 -16.837)"
                        />
                        <rect
                          id="Rectangle_1839"
                          data-name="Rectangle 1839"
                          width="3.777"
                          height="3.777"
                          transform="translate(25.528)"
                        />
                        <rect
                          id="Rectangle_1840"
                          data-name="Rectangle 1840"
                          width="3.777"
                          height="3.777"
                          transform="translate(33.082)"
                        />
                      </g>
                      <rect
                        id="Rectangle_1841"
                        data-name="Rectangle 1841"
                        width="3.777"
                        height="3.777"
                        transform="translate(40.635)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
    </div>
    <div class="sidebar-content px-4 py-6">
      <ul class="flex flex-col w-full">
        <li class="mb-6 px">
          <a
            :class="[
              $route.path == '/'
                ? 'bg-primary text-white fill-white'
                : 'bg-white text-black fill-black',
            ]"
            href="#"
            class="flex flex-row items-center h-10 px-3 rounded-lg hover:bg-primary hover:text-white"
          >
            <span class="flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g id="dashboard" transform="translate(-1361 -1475)">
                  <circle
                    id="Ellipse_1205"
                    data-name="Ellipse 1205"
                    cx="17"
                    cy="17"
                    r="17"
                    transform="translate(1361 1475)"
                    fill="none"
                  />
                  <g
                    id="svgexport-6_29_"
                    data-name="svgexport-6 (29)"
                    transform="translate(1366.4 1480.4)"
                    :fill="[$route.path == '/' ? 'white' : 'black']"
                  >
                    <g id="Layer_1" transform="translate(2 2)">
                      <g
                        id="Group_15996"
                        data-name="Group 15996"
                        transform="translate(10.267 8.893)"
                      >
                        <path
                          id="Path_25802"
                          data-name="Path 25802"
                          d="M24.236,25.307H18.7a1.7,1.7,0,0,1-1.7-1.7V16.7A1.7,1.7,0,0,1,18.7,15h5.54a1.7,1.7,0,0,1,1.7,1.7v6.914A1.7,1.7,0,0,1,24.236,25.307ZM18.7,16.374a.322.322,0,0,0-.322.322v6.914a.322.322,0,0,0,.322.322h5.54a.322.322,0,0,0,.322-.322V16.7a.322.322,0,0,0-.322-.322Z"
                          transform="translate(-17 -15)"
                        />
                      </g>
                      <g
                        id="Group_15997"
                        data-name="Group 15997"
                        transform="translate(10.267 0)"
                      >
                        <path
                          id="Path_25803"
                          data-name="Path 25803"
                          d="M24.236,9.559H18.7a1.7,1.7,0,0,1-1.7-1.7V3.7A1.7,1.7,0,0,1,18.7,2h5.54a1.7,1.7,0,0,1,1.7,1.7V7.862A1.7,1.7,0,0,1,24.236,9.559ZM18.7,3.374a.322.322,0,0,0-.322.322V7.862a.322.322,0,0,0,.322.322h5.54a.322.322,0,0,0,.322-.322V3.7a.322.322,0,0,0-.322-.322Z"
                          transform="translate(-17 -2)"
                        />
                      </g>
                      <g id="Group_15998" data-name="Group 15998">
                        <path
                          id="Path_25804"
                          data-name="Path 25804"
                          d="M9.236,12.307H3.7a1.7,1.7,0,0,1-1.7-1.7V3.7A1.7,1.7,0,0,1,3.7,2h5.54a1.7,1.7,0,0,1,1.7,1.7v6.914A1.7,1.7,0,0,1,9.236,12.307ZM3.7,3.374a.322.322,0,0,0-.322.322v6.914a.322.322,0,0,0,.322.322h5.54a.322.322,0,0,0,.322-.322V3.7a.322.322,0,0,0-.322-.322Z"
                          transform="translate(-2 -2)"
                        />
                      </g>
                      <g
                        id="Group_15999"
                        data-name="Group 15999"
                        transform="translate(0 11.641)"
                      >
                        <path
                          id="Path_25805"
                          data-name="Path 25805"
                          d="M9.236,26.559H3.7a1.7,1.7,0,0,1-1.7-1.7V20.7A1.7,1.7,0,0,1,3.7,19h5.54a1.7,1.7,0,0,1,1.7,1.7v4.165A1.7,1.7,0,0,1,9.236,26.559ZM3.7,20.374a.322.322,0,0,0-.322.322v4.165a.322.322,0,0,0,.322.322h5.54a.322.322,0,0,0,.322-.322V20.7a.322.322,0,0,0-.322-.322Z"
                          transform="translate(-2 -19)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <router-link to="/"
              ><span class="ml-3">Dashboard</span></router-link
            >
          </a>
        </li>
        <li class="mb-6 px">
          <a
            :class="[
              $route.path == '/campaigns' || $route.path == '/add-campaign'
                ? 'bg-primary text-white fill-white'
                : 'bg-white text-black',
            ]"
            class="flex flex-row items-center h-10 px-3 rounded-lg text-black hover:bg-primary hover:text-white"
          >
            <span
              class="flex items-center justify-center text-lg fill-black hover:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g id="campaigns" transform="translate(-1363 -1527)">
                  <circle
                    id="Ellipse_1201"
                    data-name="Ellipse 1201"
                    cx="17"
                    cy="17"
                    r="17"
                    transform="translate(1363 1527)"
                    fill="none"
                  />
                  <path
                    id="megaphone_1_"
                    data-name="megaphone (1)"
                    d="M13.535,0a.8.8,0,0,0-.8.8c0,2.348-2.056,3.185-3.981,3.185H3.185A3.185,3.185,0,0,0,0,7.165V8.758a3.168,3.168,0,0,0,1.205,2.475L4.049,17.58A2.574,2.574,0,0,0,6.4,19.108a2.374,2.374,0,0,0,2.166-3.344L6.814,11.942H8.758c1.924,0,3.981.837,3.981,3.185a.8.8,0,0,0,1.592,0V.8a.8.8,0,0,0-.8-.8ZM7.115,16.416a.783.783,0,0,1-.715,1.1.981.981,0,0,1-.9-.584L3.268,11.942H5.063Zm5.623-4.792A6.149,6.149,0,0,0,8.758,10.35H3.185A1.592,1.592,0,0,1,1.592,8.758V7.165A1.592,1.592,0,0,1,3.185,5.573H8.758A6.149,6.149,0,0,0,12.739,4.3Zm6.29.678a.8.8,0,0,1-1.068.357l-1.592-.8a.8.8,0,1,1,.712-1.425l1.592.8a.8.8,0,0,1,.357,1.064ZM16.011,5.137a.8.8,0,0,1,.357-1.068l1.592-.8A.8.8,0,0,1,18.672,4.7l-1.592.8A.8.8,0,0,1,16.011,5.137Zm-.088,2.825a.8.8,0,0,1,.8-.8h1.592a.8.8,0,0,1,0,1.592H16.719A.8.8,0,0,1,15.923,7.962Z"
                    transform="translate(1370.444 1534.446)"
                    :fill="[
                      $route.path == '/campaigns' ||
                      $route.path == '/add-campaign'
                        ? 'white'
                        : 'black',
                    ]"
                  />
                </g>
              </svg>
            </span>
            <router-link to="campaigns">
              <span class="ml-3">Campaigns</span>
            </router-link>
          </a>
        </li>
        <li class="mb-6 px">
          <a
            :class="[
              $route.path == '/statistics'
                ? 'bg-primary text-white fill-white'
                : 'bg-white text-black',
            ]"
            class="flex flex-row items-center h-10 px-3 rounded-lg text-black hover:bg-primary hover:text-white"
          >
            <span
              class="flex items-center justify-center text-lg fill-black hover:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g id="Statistics" transform="translate(-1363 -1568)">
                  <circle
                    id="Ellipse_1202"
                    data-name="Ellipse 1202"
                    cx="17"
                    cy="17"
                    r="17"
                    transform="translate(1363 1568)"
                    fill="none"
                  />
                  <g id="chat-arrow-grow" transform="translate(1371 1576)">
                    <path
                      id="Path_25814"
                      data-name="Path 25814"
                      d="M17.789,3.976H15.533a.731.731,0,0,0-.517,1.248l.794.794h0L13.189,8.638a.749.749,0,0,1-1.034,0l-.124-.125a2.245,2.245,0,0,0-3.1,0L5.2,12.242a.733.733,0,1,0,1.039,1.036L9.967,9.549a.748.748,0,0,1,1.034,0l.124.125a2.246,2.246,0,0,0,3.1,0l2.621-2.621h0l.794.794a.731.731,0,0,0,1.243-.518V5.073A1.1,1.1,0,0,0,17.789,3.976Z"
                      transform="translate(-1.341 -1.07)"
                      :fill="[$route.path == '/statistics' ? 'white' : 'black']"
                    />
                    <path
                      id="Path_25815"
                      data-name="Path 25815"
                      d="M16.813,16.065H3.655a2.193,2.193,0,0,1-2.193-2.193V.731A.731.731,0,1,0,0,.731V13.872a3.659,3.659,0,0,0,3.655,3.655H16.813a.731.731,0,0,0,0-1.462Z"
                      :fill="[$route.path == '/statistics' ? 'white' : 'black']"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <router-link to="/statistics">
              <span class="ml-3">Statistics</span></router-link
            >
          </a>
        </li>
        <li class="mb-6 px">
          <a
            :class="[
              $route.path == '/reports'
                ? 'bg-primary text-white fill-white'
                : 'bg-white text-black',
            ]"
            class="flex flex-row items-center h-10 px-3 rounded-lg text-black hover:bg-primary hover:text-white"
          >
            <span
              class="flex items-center justify-center text-lg fill-black hover:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g id="Reports" transform="translate(-1398 -1837)">
                  <circle
                    id="Ellipse_1204"
                    data-name="Ellipse 1204"
                    cx="17"
                    cy="17"
                    r="17"
                    transform="translate(1398 1837)"
                    fill="none"
                  />
                  <path
                    id="document_1_"
                    data-name="document (1)"
                    d="M14.316,11.5a.821.821,0,0,1-.821.821H6.927a.821.821,0,1,1,0-1.642H13.5A.821.821,0,0,1,14.316,11.5Zm-3.284,2.463H6.927a.821.821,0,1,0,0,1.642h4.105a.821.821,0,1,0,0-1.642Zm7.39-5.349V15.6a4.11,4.11,0,0,1-4.105,4.105H6.105A4.11,4.11,0,0,1,2,15.6V4.105A4.11,4.11,0,0,1,6.105,0H9.813a5.713,5.713,0,0,1,4.064,1.683l2.861,2.862A5.707,5.707,0,0,1,18.422,8.609ZM12.716,2.844a4.114,4.114,0,0,0-.863-.64V5.748a.821.821,0,0,0,.821.821h3.544a4.091,4.091,0,0,0-.641-.862ZM16.78,8.609c0-.135-.026-.265-.039-.4H12.674a2.463,2.463,0,0,1-2.463-2.463V1.681c-.133-.012-.264-.039-.4-.039H6.105A2.463,2.463,0,0,0,3.642,4.105V15.6a2.463,2.463,0,0,0,2.463,2.463h8.211A2.463,2.463,0,0,0,16.78,15.6Z"
                    transform="translate(1404.789 1844.147)"
                    :fill="[$route.path == '/reports' ? 'white' : 'black']"
                  />
                </g>
              </svg>
            </span>
            <router-link to="/reports">
              <span class="ml-3">Reports</span></router-link
            >
          </a>
        </li>
        <li class="mb-6 px">
          <a
            class="flex flex-row items-center h-10 px-3 rounded-lg text-black hover:bg-primary hover:text-white"
          >
            <span
              class="flex items-center justify-center text-lg fill-black hover:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g
                  id="Saved_videos"
                  data-name="Saved videos"
                  transform="translate(-1363 -1606)"
                >
                  <circle
                    id="Ellipse_1203"
                    data-name="Ellipse 1203"
                    cx="17"
                    cy="17"
                    r="17"
                    transform="translate(1363 1606)"
                    fill="none"
                  />
                  <path
                    id="bookmark_1_"
                    data-name="bookmark (1)"
                    d="M15.706,18.443a2.152,2.152,0,0,1-1.527-.642L9.453,13.1,4.727,17.8a2.152,2.152,0,0,1-2.378.468A2.152,2.152,0,0,1,1,16.256V3.842A3.842,3.842,0,0,1,4.842,0h9.222a3.842,3.842,0,0,1,3.842,3.842V16.256a2.152,2.152,0,0,1-1.346,2.016A2.2,2.2,0,0,1,15.706,18.443ZM4.842,1.537A2.305,2.305,0,0,0,2.537,3.842V16.256a.648.648,0,0,0,1.1.461h0l5.274-5.242a.768.768,0,0,1,1.084,0l5.268,5.24a.648.648,0,0,0,1.1-.461V3.842a2.305,2.305,0,0,0-2.305-2.305Z"
                    transform="translate(1371 1613.777)"
                  />
                </g>
              </svg>
            </span>
            <span class="ml-3">Saved Videos</span>
            <span
              class="flex items-center justify-center text-xs text-primary hover:text-white font-semibold h-6 px-2 rounded-full ml-auto"
              >Soon</span
            >
          </a>
        </li>
        <li class="mb-6 px">
          <a
            :class="[
              $route.path == '/support'
                ? 'bg-primary text-white fill-white'
                : 'bg-white text-black',
            ]"
            class="flex flex-row items-center h-10 px-3 rounded-lg text-black hover:bg-primary hover:text-white"
          >
            <span
              class="flex items-center justify-center text-lg fill-black hover:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g id="Support" transform="translate(-1363 -1648)">
                  <circle
                    id="Ellipse_1204"
                    data-name="Ellipse 1204"
                    cx="17"
                    cy="17"
                    r="17"
                    transform="translate(1363 1648)"
                    fill="none"
                  />
                  <path
                    id="info_FILL0_wght400_GRAD0_opsz48"
                    d="M13.911,18.756a.715.715,0,0,0,.738-.738V13.567a.668.668,0,0,0-.221-.5.729.729,0,0,0-.516-.209.715.715,0,0,0-.738.738v4.451a.668.668,0,0,0,.221.5A.729.729,0,0,0,13.911,18.756Zm-.074-7.722a.808.808,0,0,0,.578-.221.745.745,0,0,0,.234-.566.827.827,0,0,0-.234-.59.8.8,0,0,0-1.156,0,.827.827,0,0,0-.234.59.745.745,0,0,0,.234.566A.808.808,0,0,0,13.837,11.034Zm0,12.641a9.978,9.978,0,0,1-3.886-.75,9.521,9.521,0,0,1-5.2-5.2A9.978,9.978,0,0,1,4,13.837a9.914,9.914,0,0,1,.75-3.861A9.6,9.6,0,0,1,6.828,6.853,9.807,9.807,0,0,1,13.837,4a9.759,9.759,0,0,1,9.837,9.837,9.807,9.807,0,0,1-2.853,7.009A9.6,9.6,0,0,1,17.7,22.925,9.914,9.914,0,0,1,13.837,23.675Zm0-9.837Zm0,8.362a8.05,8.05,0,0,0,5.9-2.459,8.05,8.05,0,0,0,2.459-5.9,8.05,8.05,0,0,0-2.459-5.9,8.05,8.05,0,0,0-5.9-2.459,8.05,8.05,0,0,0-5.9,2.459,8.05,8.05,0,0,0-2.459,5.9,8.05,8.05,0,0,0,2.459,5.9A8.05,8.05,0,0,0,13.837,22.2Z"
                    transform="translate(1366.163 1651.163)"
                    :fill="[$route.path == '/support' ? 'white' : 'black']"
                  />
                </g>
              </svg>
            </span>
            <router-link to="/support">
              <span class="ml-3">Support</span></router-link
            >
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
